


<template>
	<div class="makc-alert">
		<div class="makc-alert__close-btn button--minimal" v-if="this.parent === 'inline_alert'"
			@click="this.$emit('closeAlert')"
		>&#215;
		</div>
		<div class="makc-alert__section makc-alert__section--top">
			<div class="makc-alert__title">
				{{ this.title }}
			</div>
		</div>
		<div class="makc-alert__section makc-alert__section--middle">
			<div class="makc-alert__loading" v-if="this.type === 'loader'">
				<img class="makc-alert__loading-img" src="@/create/assets/images/loading.png" alt="loading">
			</div>
			<div class="makc-alert__descr" v-if="this.type !== 'loader'">
				Попробуйте обновить страницу. <br>
				Если проблема сохраняется, <nobr>просим обратиться</nobr> по телефону горячей линии <nobr><b>8 800 333 90 13</b></nobr>
			</div>
		</div>
		<div class="makc-alert__section makc-alert__section--bottom" v-if="this.parent !== 'inline_alert' && this.type !== 'loader'">
			<button @click="this.$emit('closeDialog')" class="makc-alert__button button button--makc button--makc-blue">Назад</button>
			<!-- <button class="makc-alert__button button button--makc button--makc-unfilled">Отправить</button> -->
		</div>
	</div>
</template>

<script>
export default {
	props: ['parent'],
	props: {
		parent: {
			type: String,
			default: 'dialog'
		},
		type: {
			type: String,
			default: 'server_fail'
		},
		title: {
			type: String,
			default: 'Что-то пошло не так'
		},
	},
	data() {
		return {
		};
	},
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";
</style>
